import { select, call } from 'redux-saga/effects';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import {
  FOLDER_DEVIATIONS_STREAM_GROUP_ID,
  DEVIATION_SEARCH_RESULTS_STREAM_ID,
  FAVOURITES_SEARCH_RESULTS_STREAM_ID,
} from '../../streams/folderDeviations';
import { POSTS_DEVIATIONS_STREAM_GROUP_ID } from '../../streams/posts';
import { SHOP_ITEMS_STREAM_GROUP_ID } from '../../streams/shop';
import {
  MY_COMMENTS_STREAM,
  BADGE_ACTIVITY_STREAM,
  WATCHER_IDS_STREAM,
  WATCHING_IDS_STREAM,
  VISITOR_IDS_STREAM,
  GROUPS_MEMBER_IDS_STREAM,
  COLLECTION_FOLDER_IDS_STREAM,
  GALLERY_FOLDER_IDS_STREAM,
} from '../../streams';
import fetchMoreFolderDeviations from './fetchMoreFolderDeviations';
import fetchMoreDeviationSearchResults from './fetchMoreDeviationSearchResults';
import fetchMoreFavouritesSearchResults from './fetchMoreFavouritesSearchResults';
import fetchMoreBadgeActivity from './fetchMoreBadgeActivity';
import fetchMoreMyComments from './fetchMoreMyComments';
import fetchMoreWatchers from './fetchMoreWatchers';
import fetchMoreWatching from './fetchMoreWatching';
import fetchMoreVisitors from './fetchMoreVisitors';
import fetchMoreGroupsMember from './fetchMoreGroupsMember';
import fetchMorePosts from './fetchMorePosts';
import fetchMoreShopItems from './fetchMoreShopItems';
import { fetchMoreFolders, fetchPreviousFolders } from './fetchMoreFolders';

export function* callStreamSpecificSaga(
  action: ReturnType<typeof withOffset.actions.fetch>
) {
  const { streamId } = action;

  const groupId = yield select(state =>
    streamSelectors.getGroupId(state, streamId)
  );

  if (groupId === FOLDER_DEVIATIONS_STREAM_GROUP_ID) {
    return yield call(fetchMoreFolderDeviations, action);
  }

  if (groupId === POSTS_DEVIATIONS_STREAM_GROUP_ID) {
    return yield call(fetchMorePosts, action);
  }

  if (groupId === SHOP_ITEMS_STREAM_GROUP_ID) {
    return yield call(fetchMoreShopItems, action);
  }

  switch (streamId) {
    case BADGE_ACTIVITY_STREAM:
      return yield call(fetchMoreBadgeActivity, action);
    case WATCHER_IDS_STREAM:
      return yield call(fetchMoreWatchers, action);
    case WATCHING_IDS_STREAM:
      return yield call(fetchMoreWatching, action);
    case VISITOR_IDS_STREAM:
      return yield call(fetchMoreVisitors, action);
    case GROUPS_MEMBER_IDS_STREAM:
      return yield call(fetchMoreGroupsMember, action);
    case MY_COMMENTS_STREAM:
      return yield call(fetchMoreMyComments, action);
    case DEVIATION_SEARCH_RESULTS_STREAM_ID:
      return yield call(fetchMoreDeviationSearchResults, action);
    case FAVOURITES_SEARCH_RESULTS_STREAM_ID:
      return yield call(fetchMoreFavouritesSearchResults, action);
    case COLLECTION_FOLDER_IDS_STREAM:
    case GALLERY_FOLDER_IDS_STREAM:
      return yield call(fetchMoreFolders, action);
    default:
    // noop
  }
}

export function* callStreamSpecificSagaForPrevious(
  action: ReturnType<typeof withOffset.actions.fetchPrevious>
) {
  const {
    payload: { streamId },
  } = action;

  switch (streamId) {
    case COLLECTION_FOLDER_IDS_STREAM:
    case GALLERY_FOLDER_IDS_STREAM:
      return yield call(fetchPreviousFolders, action);
    default:
    // noop
  }
}
